import { I18n } from '@calendly/i18n'

export const getScheduleName = (isPrimaryRule, name) => {
  if (isPrimaryRule) { return I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.default_schedule', { name }) }

  return name
}
